import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import {
  Modal,
  Form,
  Button,
  DatePicker,
  Input,
  Checkbox,
  Card,
  Typography,
  Flex,
  message,
  TimePicker,
  Row,
  Col,
} from "antd";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import timeIcon from "@/assets/images/icons/time.png";
import deleteIcon from "@/assets/images/icons/delete.png";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";
const AttendanceModal = forwardRef(({ onSuccess }, ref) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const customUploadNewRef = useRef(null);
  const [accountId, setAccountId] = useState(null);
  const [employeesName, setEmployeesName] = useState(null);
  const [verifiedLocked, setVerifiedLocked] = useState(false);
  useImperativeHandle(ref, () => ({
    open: ({ date, dayData, accountId, employeesName }) => {
      setVisible(true);
      setSelectedDate(date);
      setAccountId(accountId ?? null);
      setEmployeesName(employeesName ?? null);

      // ======有数据 回显=======
      if (dayData && dayData.workItems?.length) {
        setVerifiedLocked(true);
        form.setFieldsValue({
          workItems: dayData.workItems.map((item) => {
            const start = arrayToDayjs(item.startTime);
            const end = arrayToDayjs(item.endTime);

            return {
              id: item.id,
              isLunch: item.isLunch,
              timeRange: [start, end],
              startTime: start,
              endTime: end,
              workDescription: item.isLunch
                ? "Lunch"
                : item.workDescription || "",
            };
          }),
          // verified: !!dayData.verified,
          verified: true,
          remark: dayData.remark || "",
          remarkId: dayData.remarkId || "",
        });

        // ====== 处理文件回显 ======
        if (dayData.fileList && dayData.fileList.length > 0) {
          const fileListData = dayData.fileList.map((file) => ({
            id: file.id,
            uuid: file.uuid,
            fileName: file.fileName,
            relativePath: file.relativePath,
            url: file.url,
            allPath: file.url,
            name: file.fileName,
            uid: file.id || `file-${Math.random()}`,
            status: "done",
          }));

          setFilePaths(fileListData);

          if (customUploadNewRef.current) {
            customUploadNewRef.current.initUpdateList(fileListData);
          }
        } else {
          setFilePaths([]);
          if (customUploadNewRef.current) {
            customUploadNewRef.current.initUpdateList([]);
          }
        }

        return;
      }

      // ===== 无数据：新增=====
      setVerifiedLocked(false); // 新增场景：解锁，恢复可勾选
      const [start, end] = getDefaultRange(date);

      form.setFieldsValue({
        workItems: [
          {
            isLunch: 1,
            timeRange: [start, end],
            startTime: start,
            endTime: end,
            remark: "",
            workDescription: "Lunch",
          },
        ],
        verified: false,
        remark: "",
      });

      setFilePaths([]);
      if (customUploadNewRef.current) {
        customUploadNewRef.current.initUpdateList([]);
      }
    },

    close: () => {
      setVisible(false);
      form.resetFields();
      setSelectedDate(null);
      setFilePaths([]);
      if (customUploadNewRef.current) {
        customUploadNewRef.current.initUpdateList([]);
      }
      setAccountId(null);
      setEmployeesName(null);
      setVerifiedLocked(false);
    },
  }));
  // 格式化日期
  const arrayToDayjs = (arr) => {
    if (!Array.isArray(arr)) return null;

    const [y, m, d, hh = 0, mm = 0, ss = 0] = arr;
    return dayjs(
      `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")} ${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`,
    );
  };

  const getDefaultRange = (date) => {
    const start = date.hour(9).minute(0).second(0);
    const end = date.hour(9).minute(0).second(0);
    return [start, end];
  };

  // 附件上传
  const uploadByBankApi = async (file, fieldType) => {
    const formData = new FormData();
    formData.append("files", file.originFileObj);
    formData.append("type", fieldType);

    try {
      setBtnDisabled(true);
      const res = await http.post(api.getBankUpload, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.code === "1") {
        return res.data[0];
      }
      throw new Error(res.msg || "Upload failed");
    } catch (error) {
      console.error("Upload error:", error);
      throw error;
    } finally {
      setBtnDisabled(false);
    }
  };

  const addOldFn = async (file) => {
    setBtnDisabled(true);
    const list = [file[file.length - 1]];
    const formData = new FormData();
    list.forEach((item) => formData.append("files", item.originFileObj));
    const response = await http.post(api.employmentUploadCommonFile, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.code === "1") {
      return {
        flag: true,
        fileData: response.data[0],
      };
    } else {
      return {
        flag: false,
        fileData: {},
      };
    }
  };
  const deleteOldFn = async (file) => {
    return true;
  };

  const deleteBase64FileFn = async (file) => {
    const list = filePaths.filter((item) =>
      file?.uuid ? item.uuid !== file.uuid : item.uid !== file.uid,
    );
    return list;
  };

  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();

      const remarkPayload = {
        recordDate: selectedDate.format("YYYY-MM-DD"),
        verified: values.verified ? 1 : 0,
        remark: values.remark || "",
        filePaths: filePaths.map((item) => item.relativePath),
      };
      if (values.remarkId) {
        remarkPayload.id = values.remarkId;
      }

      const params = {
        record: remarkPayload,
        workItems: values.workItems.map((item, index) => {
          const sheet = {
            workDescription: item.workDescription || "",
            startTime: item.startTime
              ? item.startTime.format("YYYY-MM-DD HH:mm:ss")
              : null,
            endTime: item.endTime
              ? item.endTime.format("YYYY-MM-DD HH:mm:ss")
              : null,
            isLunch: item.isLunch ? 1 : 0,
          };
          if (item.id) {
            sheet.id = item.id;
          }
          return sheet;
        }),
      };
      if (accountId) {
        params.accountId = accountId;
      }
      const res = await http.post(api.getManagerSave, params);
      if (res?.code === "1") {
        message.success("Attendance Created Successfully");
        setVisible(false);
        form.resetFields();
        setFilePaths([]);
        onSuccess?.();
      } else {
        Modal.error({
          title: "Operation Failed",
          content: res?.msg || "Operation failed",
          okText: "OK",
          centered: true,
        });
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  const formatWorkTime = (start, end) => {
    if (!start || !end) return "0 Hour 0 Minutes";

    const diffMinutes = end.diff(start, "Minutes");
    if (diffMinutes <= 0) return "0 Hour 0 m";

    const h = Math.floor(diffMinutes / 60);
    const m = diffMinutes % 60;

    return `${h} Hour ${m} Minutes`;
  };

  const onDeleteClick = async (field, remove) => {
    const items = form.getFieldValue("workItems") || [];
    const currentItem = items[field.name];
    if (!currentItem) return;
    await handleDeleteWorkItem(currentItem.id, remove, field.name);
  };
  const handleDeleteWorkItem = async (id, removeFn, index) => {
    Modal.confirm({
      title: "Confirm Delete",
      content: "Are you sure you want to delete this work item?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",

      onOk: async () => {
        try {
          if (id) {
            const res = await http.get(
              `${api.getManagerDele}?workItemId=${id}`,
            );
            if (res?.code === "0") {
              throw new Error(res?.msg || "Delete failed");
            }
          }
          removeFn(index);
          message.success("Deleted successfully");
        } catch (e) {
          console.error("delete failed:", e);
          message.error(e.message || "Delete failed, please try again");
          return Promise.reject(e);
        }
      },
    });
  };

  // 时间处理

  const handleStartTimeChange = (start, fieldName, form) => {
    if (!start) return;
    const end = start.add(0, "hour");
    form.setFields([
      {
        name: ["workItems", fieldName, "startTime"],
        value: start,
      },
      {
        name: ["workItems", fieldName, "endTime"],
        value: end,
      },
    ]);
  };
  const handleEndTimeChange = (time, fieldName, form) => {
    if (!time) return;

    const start = form.getFieldValue(["workItems", fieldName, "startTime"]);
    if (!start) return;

    form.setFieldValue(
      ["workItems", fieldName, "endTime"],
      start.hour(time.hour()).minute(time.minute()).second(0),
    );
  };

  return (
    <Modal
      open={visible}
      width="80%"
      style={{ top: 20 }}
      maskClosable={false}
      footer={null}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setSelectedDate(null);
        setFilePaths([]);
        setAccountId(null);
        setEmployeesName(null);
        setVerifiedLocked(false);
      }}
    >
      <Typography.Title level={4} style={{ marginBottom: 16 }}>
        {selectedDate?.format("dddd, MMM DD, YYYY")}{" "}
        {employeesName ? ` - ${employeesName}` : ""}
      </Typography.Title>

      <Row gutter={24}>
        <Col span={14}>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Card
              style={{ marginBottom: 24 }}
              title={
                <Flex align="center" gap={8}>
                  <img src={timeIcon} alt="time" width={20} />
                  <span>Time Sheet</span>
                </Flex>
              }
            >
              <Flex
                style={{
                  marginBottom: 12,
                  fontWeight: 600,
                  color: "#666",
                  paddingRight: 52,
                }}
                gap={12}
              >
                <div style={{ flex: "0 0 340px" }}>Work Time</div>
                <div style={{ flex: "0 0 510px" }}>Work Description</div>
                <div style={{ flex: "0 0 120px" }}>Work Hours</div>
              </Flex>

              <Form.List name="workItems">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field) => (
                      <Flex
                        key={field.key}
                        align="flex-start"
                        gap={12}
                        style={{ marginBottom: 16 }}
                      >
                        <div style={{ flex: "0 0 340px" }}>
                          <Form.Item shouldUpdate noStyle>
                            {() => (
                              <Flex align="center" gap={4}>
                                <Form.Item
                                  name={[field.name, "startTime"]}
                                  rules={[{ required: true }]}
                                  style={{ marginBottom: 0, flex: 1.2 }}
                                >
                                  <DatePicker
                                    showTime={{
                                      use12Hours: true,
                                      format: "hh:mm A",
                                    }}
                                    format="YYYY-MM-DD hh:mm A"
                                    placeholder="Start Time"
                                    disabledDate={(c) =>
                                      selectedDate &&
                                      !c.isSame(selectedDate, "day")
                                    }
                                    onChange={(start) =>
                                      handleStartTimeChange(
                                        start,
                                        field.name,
                                        form,
                                      )
                                    }
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                                <span style={{ color: "#999" }}>-</span>
                                <Form.Item
                                  name={[field.name, "endTime"]}
                                  rules={[{ required: true }]}
                                  style={{ marginBottom: 0, flex: 0.8 }}
                                >
                                  <TimePicker
                                    use12Hours
                                    format="hh:mm A"
                                    placeholder="End"
                                    onChange={(time) =>
                                      handleEndTimeChange(
                                        time,
                                        field.name,
                                        form,
                                      )
                                    }
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              </Flex>
                            )}
                          </Form.Item>
                        </div>

                        <div style={{ flex: 1 }}>
                          <Form.Item shouldUpdate noStyle>
                            {() => {
                              const item = form.getFieldValue([
                                "workItems",
                                field.name,
                              ]);
                              const isLunch = item?.isLunch === true;
                              return (
                                <Form.Item
                                  name={[field.name, "workDescription"]}
                                  rules={
                                    isLunch
                                      ? []
                                      : [
                                          {
                                            required: true,
                                            message: "Required",
                                          },
                                        ]
                                  }
                                  style={{ marginBottom: 0 }}
                                >
                                  <Input
                                    readOnly={isLunch}
                                    placeholder={
                                      isLunch ? "" : "Enter work description..."
                                    }
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>
                        </div>

                        <div style={{ flex: "0 0 180px" }}>
                          <Form.Item shouldUpdate noStyle>
                            {() => {
                              const item = form.getFieldValue([
                                "workItems",
                                field.name,
                              ]);
                              return (
                                <Input
                                  readOnly
                                  value={formatWorkTime(
                                    item?.startTime,
                                    item?.endTime,
                                  )}
                                  style={{
                                    background: "#2563EB",
                                    color: "#fff",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    padding: "4px 2px",
                                    borderRadius: "8px",
                                  }}
                                />
                              );
                            }}
                          </Form.Item>
                        </div>

                        <div
                          style={{
                            flex: "0 0 40px",
                            textAlign: "right",
                            paddingTop: 4,
                          }}
                        >
                          <Form.Item shouldUpdate noStyle>
                            {() => {
                              const item = form.getFieldValue([
                                "workItems",
                                field.name,
                              ]);
                              return !item?.isLunch ? (
                                <Button
                                  type="text"
                                  danger
                                  onClick={() => onDeleteClick(field, remove)}
                                  icon={
                                    <img
                                      src={deleteIcon}
                                      alt="delete"
                                      width={16}
                                    />
                                  }
                                />
                              ) : null;
                            }}
                          </Form.Item>
                        </div>
                      </Flex>
                    ))}

                    <Button
                      block
                      type="dashed"
                      style={{ height: 40, marginTop: 8 }}
                      onClick={() => {
                        const [start, end] = getDefaultRange(selectedDate);
                        add({
                          timeRange: [start, end],
                          startTime: start,
                          endTime: end,
                          workDescription: "",
                        });
                      }}
                    >
                      + New Work Content
                    </Button>
                  </>
                )}
              </Form.List>
            </Card>

            <Form.Item
              label={
                <span style={{ fontSize: 16, fontWeight: 600 }}>
                  Statement Confirmation
                </span>
              }
              name="verified"
              valuePropName="checked"
              rules={[  { validator: (_, v) => v  ? Promise.resolve()  : Promise.reject(     new Error("Please confirm the statement"),   ),}, ]}>
              <Checkbox disabled={verifiedLocked}>
                I did not work more than four consecutive hours without a
                ten-minute rest break, nor more than six consecutive hours
                without a meal break.l certify, under penalty of perjury, that
                the foregoing is true and correct, and that I have accurately
                recorded all hours worked.
              </Checkbox>
            </Form.Item>

            <Form.Item
              label={
                <span style={{ fontSize: 16, fontWeight: 600 }}>Remark</span>
              }
              name="remark"
            >
              <Input.TextArea rows={4} />
            </Form.Item>

            <Form.Item name="remarkId" hidden>
              <Input />
            </Form.Item>
          </Form>
        </Col>

        {/* 上传部分  */}
        <Col span={10}>
          <div
            style={{
              background: "#fafafa",
              padding: "20px",
              borderRadius: "8px",
              height: "100%",
              minHeight: "400px",
            }}
          >
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              Upload PDF image
            </div>
            <Form.Item
              labelCol={{ span: 0 }}
              wrapperCol={{ span: 24 }}
              label={null}
            >
              <div>
                <div className="uploadText">
                  Uploaded files only support JPG, PNG or PDF.
                </div>
                <div style={{ marginTop: "20px", display: "flex", gap: 16 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <CustomUploadNewBank
                      ref={customUploadNewRef}
                      customConfig={{
                        pdfHeight: "70vh",
                        notMultiple: true,
                        accept: ".jpg, .jpeg, .png, .pdf",
                        status: "add",
                        disabled: false,
                        noUploadBtn: false,
                        deleteOldFn: deleteOldFn,
                        addOldFn: addOldFn,
                      }}
                      setFilePaths={setFilePaths}
                      filePaths={filePaths}
                      setBtnDisabled={setBtnDisabled}
                      btnDisabled={btnDisabled}
                    />
                  </div>
                </div>
              </div>
            </Form.Item>
          </div>
        </Col>
      </Row>

      <Flex justify="center" gap={16} style={{ marginTop: 24, paddingTop: 16 }}>
        <Button onClick={() => setVisible(false)}>Close</Button>
        <Button
          type="primary"
          loading={loading}
          disabled={btnDisabled || loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </Flex>
    </Modal>
  );
});

export default AttendanceModal;
